import {ARCHIVE_LOADING, ARCHIVE_TARGET} from '../constants'

export default function showLoader(archive) {
    const archiveTarget = archive.querySelector(`[${ARCHIVE_TARGET}]`)
    const archiveLoader = archive.querySelector('.mtt-loader')
    archive.setAttribute(ARCHIVE_LOADING, 'true')

    if (!archiveLoader) {
        archiveTarget.innerHTML += '<div class="mtt-loader"></div>'
    }
}